module.exports = __webpack_public_path__ + "img/Convertible_Side_Right.8d3d814b.svg";